export default __webpack_public_path__ + "static/media/departments_ic.3e3f9f99.svg";